import React, { useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductReveal } from './components/ProductReveal';
import { ObjectionSection } from './components/ObjectionSection';
import { OfferSection } from './components/OfferSection';
import { MidPageCta } from './components/MidPageCta';
import { TestimonialSection } from './components/TestimonialSection';
import { FaqSection } from './components/FaqSection';
import { StickyCtaBar } from './components/StickyCtaBar';
import { Footer } from './components/Footer';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { DisclaimerSection } from './components/DisclaimerSection';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'terms' | 'privacy'>('home');
  if (currentPage === 'terms') {
    return <main className="w-full min-h-screen bg-warm-white selection:bg-teal/30 selection:text-navy" data-id="element-0">
        <TermsPage setCurrentPage={setCurrentPage} data-id="element-1" />
        <Footer setCurrentPage={setCurrentPage} data-id="element-2" />
      </main>;
  }
  if (currentPage === 'privacy') {
    return <main className="w-full min-h-screen bg-warm-white selection:bg-teal/30 selection:text-navy" data-id="element-3">
        <PrivacyPage setCurrentPage={setCurrentPage} data-id="element-4" />
        <Footer setCurrentPage={setCurrentPage} data-id="element-5" />
      </main>;
  }
  return <main className="w-full min-h-screen bg-warm-white selection:bg-teal/30 selection:text-navy pb-16 md:pb-0" data-id="element-6">
      <HeroSection data-id="element-7" />
      <ProblemSection data-id="element-8" />

      <MidPageCta prompt="Stop the panic before it starts." bgClass="bg-warm-white" data-id="element-9" />

      <ProductReveal data-id="element-10" />

      <TestimonialSection data-id="element-11" />

      <ObjectionSection data-id="element-12" />

      <MidPageCta prompt="Get the system that works when you can't." bgClass="bg-cream" data-id="element-13" />

      <FaqSection data-id="element-14" />

      <OfferSection data-id="element-15" />

      <DisclaimerSection data-id="element-16" />

      <Footer setCurrentPage={setCurrentPage} data-id="element-17" />

      <StickyCtaBar data-id="element-18" />
    </main>;
}